<template>
  <v-container class="mt-5">
    <v-layout row wrap justify-space-around v-if="error">
      <v-flex xs12 sm6 lg4>
        <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-space-around>
      <v-flex xs12 sm6 lg4>
        <v-alert
          v-model="successAlert"
          dismissible
          type="success">{{ $t('receiveEmail') }}</v-alert>
        <v-alert
          v-model="errorAlert"
          dismissible
          type="error">{{errorMessage}}</v-alert>
        <v-card>
          <v-card-text>
            <v-form ref="form" v-model="isValid" lazy-validation>
              <v-layout>
                <v-text-field
                  prepend-icon="mail"
                  :label="$t('loginEmail')"
                  name="email"
                  id="email"
                  v-model="email"
                  type="email"
                  :rules="[fieldIsEmail(), fieldIsRequired('email')]"
                  @keyup.enter="onFormSubmitted"
                  class="required_field"></v-text-field>
              </v-layout>
              <v-layout align-center justify-end>
                <a @click.stop="showResetPasswordEmailDialog">{{ $t('forgetPassword') }}?</a>
                <v-tooltip top v-if="isNonVPN">
                  <template v-slot:activator="tooltip">
                    <div v-on="tooltip.on">
                      <v-btn icon @click.stop="isShowParseUrlPopup = true" color="primary" flat><v-icon>fast_forward</v-icon></v-btn>
                    </div>
                  </template>
                  {{ $t('parseUrl') }}
                </v-tooltip>
                <LoaderButton
                  :buttonText="$t('send')"
                  :promiseAwait="onFormSubmitted"
                  :disabled="!isValid || btnLoading"
                  :loading="btnLoading"></LoaderButton>
              </v-layout>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <ResetPasswordEmailPopup v-model="resetPasswordEmailDialog" />
    <ParseSignupUrlPopup
      v-model="isShowParseUrlPopup"
      :email="email"
    />
  </v-container>
</template>

<script>
import SimpleTextPopup from './SimpleTextPopup'
import LoaderButton from './LoaderButton'
import { checkRules } from '@/utils/tools'
import ParseSignupUrlPopup from './ParseSignupUrlPopup.vue'
import ResetPasswordEmailPopup from './ResetPasswordEmailPopup.vue'
export default {
  name: 'Signup',
  components: {
    SimpleTextPopup,
    LoaderButton,
    ParseSignupUrlPopup,
    ResetPasswordEmailPopup
  },
  mixins: [checkRules],
  data () {
    return {
      referral: '',
      email: '',
      resetPasswordEmailDialog: false,
      errorAlert: false,
      successAlert: false,
      errorMessage: '',
      isValid: true,
      btnLoading: false,
      isShowParseUrlPopup: false
    }
  },
  computed: {
    error () {
      return this.$store.getters.error
    },
    isNonVPN () {
      return this.$store.getters.isNonVPN
    }
  },
  beforeMount () {
    this.$store.dispatch('clearError')
  },
  methods: {
    onFormSubmitted () {
      if (!this.$refs.form.validate()) return Promise.reject(Error('Form validate failed.'))
      return this.$store.dispatch('checkEmailAvailable', this.email)
        .then(rtn => {
          if (rtn) {
            this.errorAlert = false
            this.successAlert = true
            return this.$store.dispatch('sendEmailVerification', this.email)
              .then(() => { this.successAlert = true })
          }
          return Promise.reject(new Error('duplicate-email'))
        })
        .catch(error => {
          this.successAlert = false
          this.errorAlert = true
          if (error.message === 'duplicate-email') {
            this.errorMessage = this.$t('emailAlreadyExists')
          } else {
            this.errorMessage = this.$t('networkIssue')
          }          
          console.log(error.message)
          return Promise.reject(new Error(this.errorMessage))
        })
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    dispatchAndToast (promise, actionText) {
      promise
        .catch(error => {
          this.$store.dispatch('showToast', {info: `${actionText} ${this.$t('failed')}. ` + error.message})
        })
    },
    showResetPasswordEmailDialog () {
      this.resetPasswordEmailDialog = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Signup.vue